import React from 'react';

const LocationInfo = () => {
    return (
        <>
            <div className="location-info">
                <h3>당신의 위치:</h3>
                <div id="user-location"></div>
                <div id="user-map" className="map"></div>
            </div>
            <div className="location-info">
                <h3>반대편 위치:</h3>
                <div id="antipode-location"></div>
                <div id="antipode-map" className="map"></div>
            </div>
        </>
    );
};

export default LocationInfo;
